var map = {
	"./components/Background.vue": 8382,
	"./components/ExampleComponent.vue": 9899,
	"./components/Result.vue": 3353,
	"./components/Timer.vue": 8203,
	"./components/screens/FormScreen.vue": 1704,
	"./components/screens/GameScreen.vue": 6487,
	"./components/screens/IntroScreen.vue": 5875,
	"./components/screens/LevelIntroScreen.vue": 7677,
	"./components/screens/MainScreen.vue": 736,
	"./components/screens/ScoreScreen.vue": 1838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2108;